module.exports = __webpack_public_path__ + "img/cuowu_sel.bd9c02c7.png";